import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { Thumbnails } from "./Thumbnails";
import { List } from "./List";
import MembersContext from "../../../../application/Context/MembersContext";
export var Views = function () {
    var view = useContext(MembersContext).view;
    return (_jsx(React.Fragment, { children: view === "carte" ? _jsx(Thumbnails, {}) : _jsx(List, {}) }));
};
